import { Box, Button, styled } from "@mui/material";
import AuthenticateLayout from "../../components/AuthenticateLayout";
import SVG from "react-inlinesvg";
import { useState } from "react";
import RewardWhiteIcon from "../../assets/icons/Reward-white.svg";
import Gift3 from "../../assets/icons/gift3.svg";
import Gift4 from "../../assets/icons/gift4.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { Loading } from "../../components";
import { useTranslation } from "react-i18next";
import { links } from "../../constants/links";
import ChangeLanguage from "../../components/ChangeLanguage";
import { ENV } from "../../configs/env";


const AlertTitle = styled(Button)({
  justifyContent: "center",
  backgroundColor: "rgba(17, 85, 170, 0.1)",
  color: "#1155AA",
  fontSize: 28,
  fontWeight: 500,
  pointerEvents: "none",
});

const AlertMessage = styled(Button)({
  marginTop: 20,
  justifyContent: "center",
  color: "#1155AA",
  fontSize: 16,
  fontWeight: 500,
  paddingInline: 18,
  textAlign: "center",
  lineHeight: "20px",
  pointerEvents: "none",
});

const Footer = styled(Box)(`
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 10px 15px 40px 15px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
`);

const GetGiftBtn = styled(Button)({
  width: "100%",
  fontWeight: 400,
  fontSize: 14,
  height: 48,
  position: "relative",
  "&:hover": {
    backgroundColor: "#1155AA",
  },
  "& .giftIcon1": {
    position: "absolute",
    bottom: 0,
    left: "14%",
  },
  "& .giftIcon2": {
    position: "absolute",
    top: 0,
    right: "20%",
  },
});

const ENGAGED = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const id = location.state?.subcampaign_id;
  const last_engaged_session = location.state?.last_engaged_session;
  const is_3rdparty_coupon_use = location.state?.is_3rdparty_coupon_use;
  const coupon_code = location.state?.coupon_code;

  const advertiser_banner = location.state?.advertiser_banner;
  const banner_image_corner = location.state?.banner_image_corner;
  const [isLoading, setIsLoading] = useState(false);

  const goToRewardList = () => {
    if (last_engaged_session){
      navigate(`${links.USE_REWARD_V2}/?engage-session=${last_engaged_session}`);
    } else {
      navigate(links.USE_REWARD.replace(":id", id));
    }
  };
  //   if (is_3rdparty_coupon_use) {
  //     window.location.href = coupon_code
  //   } else {
  //     navigate(links.USE_REWARD.replace(":id", id));
  //   }
  // };

  return (
    <>
      {(isLoading && <Loading />) && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
      <AuthenticateLayout
        button={() => !ENV.HIDE_TRANSLATOR && <ChangeLanguage />}
        isLoading={isLoading}
        background={advertiser_banner}
        bannerImageCorner={banner_image_corner}
        hideLogo={ENV.HIDE_LOGO}
      >
        <Box
          px={2.5}
          mt={6}
          pb={21}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          {
            <>
              <AlertTitle fullWidth variant="contained">
                {t("youHaveEngaged")}
              </AlertTitle>
            </>
          }
          <Box display="flex" justifyContent="space-between">
            <AlertMessage fullWidth>
              {t("engageAlertMessage1")}
              <br /><br />
              {t("engageAlertMessage2")}
            </AlertMessage>
          </Box>
          <Footer>
            <GetGiftBtn
              variant="contained"
              startIcon={<SVG src={RewardWhiteIcon} />}
              onClick={() => goToRewardList()}
            >
              <SVG className="giftIcon1" src={Gift3} />
              <SVG className="giftIcon2" src={Gift4} />
              {
                t("rewards")
              }
            </GetGiftBtn>
          </Footer>
        </Box>
      </AuthenticateLayout>
    </>
  );
};

export default ENGAGED;
